import { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaShoppingCart,
  FaBars,
  FaTimes,
  FaChevronDown,
  FaHome,
  FaInfoCircle,
  FaPhone,
  FaClipboardCheck,
  FaChalkboardTeacher,
  FaCheckDouble,
  FaHandshake,
  FaHardHat,
  FaBriefcaseMedical,
  FaWarehouse,
  FaTruck,
  FaBolt,
  FaFlask,
  FaRoad,
  FaGlobe,
  FaFireExtinguisher
} from "react-icons/fa";
import "./Navbar.css";
import logoImage from "./wecare.png";
import { AuthContext } from "../context/AuthContext";

function Navbar() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const { isAuthenticated, isAdminAuthenticated, user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
    document.body.classList.toggle("sidebar-open", !isMobileSidebarOpen);
  };

  const handleMobileItemClick = (path) => {
    navigate(path);
    setIsMobileSidebarOpen(false);
    document.body.classList.remove("sidebar-open");
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const menuItems = [
    { name: "Home", path: "/", icon: <FaHome /> },
    { name: "About Us", path: "/about", icon: <FaInfoCircle /> },
    { name: "Contact Us", path: "/contact", icon: <FaPhone /> },
    {
      name: "Audit",
      path: "/Audit",
      icon: <FaClipboardCheck />,
      subItems: [
        { name: "ISO 9001", path: "/Audit/ISO9K1" },
        { name: "ISO 14001", path: "/Audit/ISO14K1" },
        { name: "ISO 45001", path: "/Audit/ISO45K1" },
        { name: "OHSMS Audit", path: "/Audit/OHSMS" },
        { name: "Safety Assessment", path: "/Audit/SafetyAssessment" },
      ],
    },
    {
      name: "Training",
      path: "/training",
      icon: <FaChalkboardTeacher />,
      subItems: [
        {
          name: "General Safety",
          path: "/training/general-safety",
          icon: <FaHardHat />,
          subItems: [
            { name: "Environmental Safety", path: "/training/general/environmental" },
            { name: "Safety Awareness", path: "/training/general/safety-awareness" },
            { name: "Behaviour Based Safety", path: "/training/general/behaviour" },
            { name: "5S Concepts", path: "/training/general/sconcepts" },
            { name: "Use of PPE", path: "/training/general/PPE" },
            { name: "LOTO (Lock Out Tag Out)", path: "/training/general/LOTO" },
          ],
        },
        {
          name: "Health Safety",
          icon: <FaBriefcaseMedical />,
          subItems: [
            { name: "First Aid with Practical", path: "/training/health/firstaid" },
            { name: "Heat and Cold Stress", path: "/training/health/heatcoldstress" },
            { name: "Workplace Ergonomics", path: "/training/health/ergonomics" },
            { name: "Mental Wellbeing", path: "/training/health/mental" },
          ],
        },
        {
          name: "Warehouse Safety",
          icon: <FaWarehouse />,
          subItems: [
            { name: "Warehouse Safety", path: "/training/warehouse" },
            { name: "MHE Driving Safety", path: "/training/MHE" },
            { name: "Crane Safety", path: "/training/crane" },
          ],
        },
        {
          name: "Construction Safety",
          icon: <FaTruck />,
          subItems: [
            { name: "Construction Safety", path: "/training/constructionsafety" },
            { name: "Working at Height Safety", path: "/training/workingatheight" },
            { name: "Hot Work Safety", path: "/training/hotwork" },
            { name: "Excavation Safety", path: "/training/excavation" },
            { name: "Confined Space Safety", path: "/training/confinedspace" },
          ],
        },
        { name: "Electrical Safety", path: "/training/electrical", icon: <FaBolt /> },
        { name: "Chemical Safety", path: "/training/chemical", icon: <FaFlask /> },
        { name: "Road Safety", path: "/training/road", icon: <FaRoad /> },
        {
          name: "ISO Training",
          icon: <FaGlobe />,
          subItems: [
            { name: "ISO 9001 Auditor", path: "/training/isotraining/ISO9001" },
            { name: "ISO 14001 Auditor", path: "/training/isotraining/ISO14001" },
            { name: "ISO 45001 Auditor", path: "/training/isotraining/ISO45001" },
            { name: "ISO 19011 Auditor", path: "/training/isotraining/ISO19011" },
            { name: "ISO Documentation", path: "/training/isotraining/isodocumentation" },
            { name: "HIRA and Control Methods", path: "/training/isotraining/HIRA" },
          ],
        },
        {
          name: "Emergency Preparedness",
          path: "/training/emergencypreparedness",
          icon: <FaFireExtinguisher />,
          subItems: [
            { name: "Fire Safety with Practical", path: "/training/firesafety" },
            { name: "Emergency Preparedness", path: "/training/emergency" },
          ],
        },
      ],
    },
    {
      name: "Compliance",
      path: "/compliance",
      icon: <FaCheckDouble />,
      subItems: [
        { name: "Safety Legal Compliance", path: "/compliance/safetylegalcompliance" },
        { name: "ISO 14001", path: "/compliance/ISO14001Comp" },
        { name: "ISO 45001", path: "/compliance/ISO45001Comp" },
      ],
    },
    {
      name: "Consultancy",
      path: "/consultancy",
      icon: <FaHandshake />,
      subItems: [
        { name: "Safety Legislation", path: "/consultancy/safetylegislation" },
        { name: "ISO 9001", path: "/consultancy/ISO9001Cons" },
        { name: "ISO 14001", path: "/consultancy/ISO14001Cons" },
        { name: "ISO 45001", path: "/consultancy/ISO45001Cons" },
        { name: "Risk Reduction", path: "/consultancy/riskreduction" },
        { name: "RCA", path: "/consultancy/RCA" },

      ],
    },
  ];

  /* 
     SYSTEMATIC MOBILE MENU 
     - Recursive with clear visual hierarchy
     - Accordion style
  */
  const MobileMenuList = ({ items, level = 0 }) => {
    // State to track ALL open submenus by index
    // Using simple logic: only one item open at a time per level? 
    // Or multiple? User asked for systematic. Multiple is easier for user to scan.
    const [openMenus, setOpenMenus] = useState({});

    const toggleMenu = (index, e) => {
      e.stopPropagation();
      setOpenMenus(prev => ({ ...prev, [index]: !prev[index] }));
    };

    return (
      <div className={`mobile-menu-level level-${level}`}>
        {items.map((item, index) => {
          const hasChildren = item.subItems && item.subItems.length > 0;
          const isOpen = openMenus[index];

          return (
            <div key={index} className={`mobile-menu-wrapper-item ${isOpen ? 'is-open' : ''}`}>

              {/* Menu Item Header */}
              <div
                className={`mobile-menu-item level-${level}-item`}
                onClick={() => {
                  if (hasChildren) {
                    // Just toggle
                    // If it has children, the click on the whole row toggles it (mobile friendly)
                    // If users want to go to the parent page, they might be blocked if we strictly toggle.
                    // Assuming parent paths are just categories mostly, except 'Training' etc.
                    // Strategy: If it has children, the text toggles. 
                    toggleMenu(index, { stopPropagation: () => { } });
                  } else {
                    handleMobileItemClick(item.path);
                  }
                }}
              >
                <div className="mobile-item-content">
                  {item.icon && <span className="mobile-item-icon">{item.icon}</span>}
                  <span className="mobile-item-text">{item.name}</span>
                </div>

                {hasChildren && (
                  <span className={`mobile-chevron ${isOpen ? 'rotate' : ''}`}>
                    <FaChevronDown />
                  </span>
                )}
              </div>

              {/* Submenu Container */}
              {hasChildren && (
                <div
                  className={`mobile-submenu-container ${isOpen ? 'expanded' : 'collapsed'}`}
                >
                  <MobileMenuList items={item.subItems} level={level + 1} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const DesktopMenuList = ({ items, level = 0 }) => {
    return (
      <ul className={`menu-list level-${level} desktop-menu`}>
        {items.map((item, index) => (
          <li key={index} className="menu-item">
            {item.subItems ? (
              <>
                <span className="menu-title">{item.name}</span>
                <div className="submenu-container">
                  <DesktopMenuList items={item.subItems} level={level + 1} />
                </div>
              </>
            ) : (
              <Link to={item.path} className="menu-title">
                {item.name}
              </Link>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="left-section">
          {isMobile && (
            <div className="mobile-menu-icon" onClick={toggleMobileSidebar}>
              {isMobileSidebarOpen ? <FaTimes /> : <FaBars />}
            </div>
          )}
          <h1 className="logo" onClick={() => navigate("/")} style={{ cursor: 'pointer' }}>
            <img src={logoImage} alt="Logo" />
          </h1>
        </div>

        {!isMobile && (
          <div className="desktop-menu-container">
            <DesktopMenuList items={menuItems} />
          </div>
        )}

        <div className="right-section">
          {isAuthenticated || isAdminAuthenticated ? (
            <>
              {!isMobile && (
                <div className="user-profile-container">
                  <div className="user-controls">
                    <button className="user-profile-button" aria-label="User profile">
                      {user && user.avatar ? (
                        <img src={user.avatar} className="user-avatar" alt="User avatar" />
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="user-avatar"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="12" cy="7" r="5" />
                          <path d="M12 14c-4 0-7 2-7 5v1h14v-1c0-3-3-5-7-5z" />
                        </svg>
                      )}
                      <span className="username">{user ? user.username || "" : ""}</span>
                    </button>
                    <button
                      className="logout-button"
                      onClick={handleLogout}
                      aria-label="Logout"
                    >
                      Logout
                    </button>
                  </div>
                </div>
              )}
              <div className="dashboard-button">
                <Link to="/dashboard" className="dashboard-link" aria-label="Dashboard">
                  Dashboard
                </Link>
              </div>
            </>
          ) : (
            <div className="login-button">
              <Link to="/login" className="login-link" aria-label="Login">
                Login
              </Link>
            </div>
          )}

          <button
            className="cart-button"
            onClick={() => navigate("/cart")}
            aria-label="Cart"
          >
            <FaShoppingCart size={20} color="#ffffff" />
          </button>
        </div>

        {/* --- MOBILE SIDEBAR --- */}
        <div className={`mobile-sidebar ${isMobileSidebarOpen ? "open" : ""}`}>
          <div className="sidebar-header">
            <h1 className="logo">
              <img src={logoImage} alt="Logo" />
            </h1>
            <button className="sidebar-close-btn" onClick={toggleMobileSidebar} aria-label="Close menu">
              <FaTimes />
            </button>
          </div>

          <div className="mobile-menu-wrapper">
            <div className="mobile-menu-scrollable">
              {/* User Info Section Mobile */}
              {isAuthenticated && (
                <div className="mobile-user-card">
                  <div className="mobile-avatar">
                    {user && user.avatar ? (
                      <img src={user.avatar} alt="User" />
                    ) : (
                      <FaHome />
                    )}
                  </div>
                  <div className="mobile-user-details">
                    <span className="mobile-username">{user ? user.username : "User"}</span>
                    <span className="mobile-status">Active Member</span>
                  </div>
                </div>
              )}

              <MobileMenuList items={menuItems} />

              {/* Login/Sign Up Button - Moved here from footer */}
              {!isAuthenticated && !isAdminAuthenticated && (
                <div style={{ padding: '16px 24px' }}>
                  <button
                    className="mobile-login-full-btn"
                    onClick={() => {
                      navigate("/login");
                      toggleMobileSidebar();
                    }}
                  >
                    Login / Sign Up
                  </button>
                </div>
              )}

              <div style={{ height: '40px' }}></div> {/* Spacing */}
            </div>
          </div>

          <div className="mobile-menu-footer">
            {isAuthenticated && (
              <button
                className="mobile-logout-button"
                onClick={handleLogout}
              >
                Logout
              </button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;